import { render, staticRenderFns } from "./liveClassToBeReviewedNew.vue?vue&type=template&id=26f904a8"
import script from "./liveClassToBeReviewedNew.vue?vue&type=script&lang=js"
export * from "./liveClassToBeReviewedNew.vue?vue&type=script&lang=js"
import style0 from "./liveClassToBeReviewedNew.vue?vue&type=style&index=0&id=26f904a8&prod&lang=less&scope=true"
import style1 from "./liveClassToBeReviewedNew.vue?vue&type=style&index=1&id=26f904a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports